import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Media from 'react-media';
import composes from '../../../../common/utils/composes';
import { withTheme } from 'glamorous';
import withCustomerOrg from '../../../../common/components/withCustomerOrg';
import { withLoading } from '../../../../redux-modules/loading-overlay';
import withGeolocated from '../../components/withGeolocated';
import Dialog from 'react-toolbox/lib/dialog';
import { IconButton, Button } from 'react-toolbox/lib/button';
import CurrentUserActions from '../../../../redux-modules/current-user';
import EventActions from '../../actions/events';
import { getDisplayEvents } from '../../selectors/events';
import CheckBoxList from '../../components/CheckboxList';
import Drawer from '../../components/Drawer';
import Message from '../../components/Message';
import EventCard from '../../components/EventCard';
import EventList from '../../components/EventList';
import States from '../../../../common/states.json';
import ButtonLink from '../../../../common/components/ButtonLink';
import LoadingView from '../../../../common/components/LoadingView';
import styles from './Catalog.css';
import {
  TitleBar,
  ServiceDialog,
  DocTitle,
} from '../../../../common/components/Layout/StandardPageTemplate/Context';
import {
  SortProperty,
  genericObjectSort,
} from '../../../../common/utils/object-sort';
import { getStateAbbr, isEventNational } from '../../utils';

class Catalog extends React.Component {
  static propTypes = {
    actions: PropTypes.shape({
      events: PropTypes.object,
    }),
  };
  static promises = {
    includePromises: [
      {
        type: 'ENTITY/ENTITY_GET',
        // meta: { namespace: 'events' },
      },
    ],
  };
  static sortOrder = [
    new SortProperty('legislatureTypeSort'),
    new SortProperty('location.stateAbbreviation'),
    new SortProperty('startDate'),
    new SortProperty('location.city'),
    new SortProperty('title'),
  ];
  state = {
    serverError: false,
    dialogIsActive: false,
    drawerActive: false,
    filters: [],
    hasSessionFilters: false,
    isGeolocationDataSet: false,
    isCurrentUserDataSet: false,
    isFetchingEvents: true,
  };

  async componentWillMount() {
    const filters = this.getStateFiltersFromSession();
    await this.setState({
      filters,
      hasSessionFilters: filters.length > 0,
    });
    this.checkUserDataForStateFilters();
  }

  componentDidMount() {
    this.props.actions.events
      .get()
      .then(result => {
        this.setState({ isFetchingEvents: false });
        this.checkServerError(result);
      })
      .catch(() => this.setState({ isFetchingEvents: false }));
  }

  componentWillReceiveProps(nextProps) {
    // don't overwrite filters or change filters while loading
    if (nextProps.isLoading) {
      return;
    }

    const {geolocation, currentCustomer} = nextProps;
    const {currentCustomer: prevCurrentCustomer} = this.props;
    //set by business or personal address if found
    if (geolocation || (currentCustomer !== prevCurrentCustomer)) {
      this.checkUserDataForStateFilters(nextProps);
    }
  }

  checkUserDataForStateFilters = nextProps => {
    const props = nextProps || this.props;
    const {hasSessionFilters, isCurrentUserDataSet, isGeolocationDataSet} = this.state;
    const {currentCustomer, currentUser, actions, geolocation} = props;

    if (hasSessionFilters || isCurrentUserDataSet) {
      return;
    }

    if (geolocation && geolocation.state && !isGeolocationDataSet) {
      const filters = States.filter(s => s.name === geolocation.state);
      if (filters && filters.length > 0) {
        this.setState({filters, isGeolocationDataSet: true});
        this.setStateFilterForSession(filters);
      }
    }

    //set by business or personal address if found
    if (currentCustomer) {
      if (!currentUser || !currentUser.id) {
        actions.currentUser.setId(currentCustomer.key);
        actions.currentUser.updateSettings({
          email: currentCustomer.contactDetails.emailAddress,
        });
      }
      const {organization = {}, personalAddress = {}} = currentCustomer;
      const orgAddresses = (organization && organization.addresses) || [];
      const businessAddress = orgAddresses.find(
        address => address.type && address.type.toLowerCase() === 'business'
      );
      // business address wins if the account has one on file; otherwise
      // fall back to the personal address - don't just assume addresses[0]
      // is the business one, since org address order isn't guaranteed
      const currentState =
        (businessAddress && businessAddress.stateCode) ||
        personalAddress.stateCode;
      const filters = States.filter(s => s.id === currentState);
      // Only "lock in" customer-derived filters if we actually found a valid state.
      // Otherwise, allow geolocation to populate filters.
      if (filters && filters.length > 0) {
        this.setState({filters, isCurrentUserDataSet: true});
        this.setStateFilterForSession(filters);
      }
    }
  }

  // TODO: can we centralize this somehow?
  checkServerError = ({ payload: { resp: { status = 0 } = {} } = {} }) => {
    if (status >= 500 && status < 600) {
      this.setState({ serverError: true });
    }
  };

  toggleDialog = () => {
    this.setState(prevState => ({
      dialogIsActive: !prevState.dialogIsActive,
    }));
  };

  getEventsMessage = events => {
    const { isFetchingEvents } = this.state;

    if (isFetchingEvents) {
      // LoadingView already communicates the loading state - avoid a
      // second, redundant "Loading..." message underneath it
      return null;
    }

    var filters = this.state.filters;
    try {
      if (filters == null || filters === '' || filters.length < 1) {
        var mySession = JSON.parse(sessionStorage.getItem('engage-settings'));
        if (
          mySession != null &&
          mySession.settings != null &&
          mySession.settings.stateFilters &&
          mySession.settings.stateFilters.length > 0
        ) {
          filters = mySession.settings.stateFilters;
        }
      }
    } catch (Exception) {}
    if (events.filter(e => !isEventNational(e)).length === 0) {
      if (filters.length === 0) {
        return 'No states are currently selected';
      } else if (filters.length === 1) {
        return `No state-level events are currently scheduled for ${filters[0].name}`;
      } else if (filters.length > 1) {
        return 'No events are currently scheduled for the selected states';
      }
      return null;
    }
    return null;
  };

  handleDrawerToggle = () => {
    this.setState(prevState => ({
      drawerActive: !prevState.drawerActive,
    }));
  };

  toggleFilterHandler = value => () => {
    let filters = this.state.filters;
    if (filters.some(f => f.id === value.id)) {
      filters = filters.filter(f => f.id !== value.id);
    } else {
      filters = filters.concat([value]);
    }
    this.setState({filters});
    this.setStateFilterForSession(filters);
  };

  isChecked = value => {
    return this.state.filters.some(f => f.id === value.id);
  }

  getStateFiltersFromSession = () => {
    const {currentUser: {settings = {}}} = this.props;
    return settings.stateFilters || [];
  }

  setStateFilterForSession = (stateFilters) => {
    this.props.actions.currentUser.updateSettings(stateFilters.length < 1 ? null : {stateFilters});
  }

  render() {
    const {
      serverError,
      dialogIsActive,
      drawerActive,
      filters,
      isFetchingEvents,
    } = this.state;
    const { events } = this.props;
    const filteredEvents = events.filter(
      e =>
        isEventNational(e) || filters.map(i => i.id).includes(getStateAbbr(e))
    );
    const message = this.getEventsMessage(filteredEvents);
    return (
      <div>
        {serverError ? <ServiceDialog /> : null}
        <DocTitle title="Events | NFIB" />
        <TitleBar title="Events">
          <Media query="(max-width: 900px)">
            {matches => {
              const buttonProps = {
                icon: 'filter_list',
                style: { marginLeft: 'auto' },
                onClick: this.handleDrawerToggle,
              };
              if (matches) {
                return <IconButton {...buttonProps} />;
              } else {
                //provide label for desktop
                return <Button label="Filter By State" {...buttonProps} />;
              }
            }}
          </Media>
        </TitleBar>
        <div className={styles.navRow}>
          <ButtonLink to="/account" label="Back to Account Management" />
          <ButtonLink to="/account/events" label="My Events" />
        </div>
        {isFetchingEvents ? (
          <LoadingView />
        ) : (
          <EventList>
            {filteredEvents.map(event => (
              <EventCard
                key={event.key}
                event={event}
                onEventFullClick={this.toggleDialog}
              />
            ))}
          </EventList>
        )}
        {message && <Message>{message}</Message>}
        <Dialog
          title="Max Capacity"
          actions={[{ label: 'Close', onClick: this.toggleDialog }]}
          active={dialogIsActive}
          onEscKeyDown={this.toggleDialog}
          onOverlayClick={this.toggleDialog}
        >
          <div style={{ fontSize: '1.6rem' }}>
            <p>
              Thank you for your interest in this NFIB event. Currently, no
              seats are available. If you have questions, please contact NFIB by
              calling the number provided in the event details or
              1-800-NFIB-NOW.
            </p>
          </div>
        </Dialog>
        <Drawer active={drawerActive} handleToggle={this.handleDrawerToggle}>
          <CheckBoxList
            title={'Filter By State'}
            list={States}
            isChecked={this.isChecked}
            onChange={this.toggleFilterHandler}
          />
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    events: getDisplayEvents(state).sort(genericObjectSort(Catalog.sortOrder)),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      events: bindActionCreators(EventActions, dispatch),
      currentUser: bindActionCreators(CurrentUserActions, dispatch),
    },
  };
};

export default composes(
  Catalog,
  withLoading,
  connect(mapStateToProps, mapDispatchToProps),
  withTheme,
  withCustomerOrg,
  withGeolocated
);



// WEBPACK FOOTER //
// ./src/App/events/Views/Catalog/index.js